import { createFileRoute } from '@tanstack/react-router'
import { OrderReviewFindingPage } from '@/pages/order-review-finding'

export const Route = createFileRoute('/_authenticated/order-review/$findingId')({
  staticData: { title: 'Order review' },
  component: OrderReviewFindingRoute,
})

function OrderReviewFindingRoute() {
  const { findingId } = Route.useParams()
  return <OrderReviewFindingPage findingId={findingId} />
}
